<mat-drawer-container class="container-position">

  <mat-drawer #sideNav mode="side" opened="false" position="end" class="drawer">
    <div>
      <br />
      <div class="header-class">

        <div class="col-6">
          <h6>Filtres</h6>
        </div>
        <div class="col-6">
          <button color="warn" mat-raised-button (click)="clearFiltre()">
            <mat-icon>cancel</mat-icon> Réinitialiser
          </button>

        </div>
      </div>
    </div>
    <br />
    <div class="data-class" *ngIf="filtreData">
      <br />
      <div class="row margin_tm_20">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.societe" name="societe" (objetChange)="onChange($event);"
            libelle="Société" [objets]="societes" [required]="false">
          </app-autocomplete-with-code>
        </div>
      </div>
      <!-- Site -->
      <div class="row ">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code (objetChange)="onChange($event)" libelle="Site" [objets]="sites"
          [(objet)]="filtreData.bpSite" name="Site" [required]="false" (loadData)="loadData($event, siteService, 'sites')">
          </app-autocomplete-with-code>
        </div>
      </div>
      <!-- Fournisseur -->
      <div class="row">
        <div class="col-sm-10 margin_bm_20">
          <app-autocomplete-with-code (objetChange)="onChange($event)" libelle="Fournisseur" [objets]="fournisseurs"
            [(objet)]="filtreData.bpFourn" (loadData)="loadData($event, fournisseurService, 'fournisseurs')"></app-autocomplete-with-code>
        </div>
        <div class="col-sm-1 margin_bm_20">
          <mat-icon style="margin-top: 10px;" type="submit" (click)="openModalFournisseur()" id="search">search</mat-icon>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Libellé Fournisseur</mat-label>
            <input matInput [(ngModel)]="filtreData.libelleFourn" (ngModelChange)="onChange($event)" name=""
              style="font-size: small;" [ngModelOptions]="{standalone: true}" name="refFourn">
          </mat-form-field>
        </div>
      </div>
      <!-- CA1 -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.bpCa1" (objetChange)="onChange($event)" libelle="Ca1"
            [objets]="ca1s" name="Ca1"  (loadData)="loadData($event, ca1Service, 'ca1s')">
          </app-autocomplete-with-code>
        </div>
      </div>
      <!-- CA2 -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.bpCa2"  (objetChange)="onChange($event)" libelle="Ca2" 
          [objets]="ca2s" (loadData)="loadData($event, ca2Service, 'ca2s')">
          </app-autocomplete-with-code>
        </div>
      </div>
      <!-- NA --> 

      <div class="row">
        <div class="col-sm-6 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.startNa"  (objetChange)="onChange($event)" libelle="Na: de" 
          [objets]="nasStart" (loadData)="loadData($event, naService, 'nasStart')">
          </app-autocomplete-with-code>
        </div>
        <div class="col-sm-6 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.endNa"  (objetChange)="onChange($event)" libelle="au" 
          [objets]="nasEnd" (loadData)="loadData($event, naService, 'nasEnd')">
          </app-autocomplete-with-code>
        </div>
      </div>

      <!-- code chantier -->
      <div class="row">
        <div class="col-sm-6 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Code Chantier: de</mat-label>
            <input matInput [(ngModel)]="filtreData.startChantier" (ngModelChange)="onChange($event)"
              name="CodeChantier" style="font-size: small;" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        <div class="col-sm-6 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>à</mat-label>
            <input matInput [(ngModel)]="filtreData.endChantier" (ngModelChange)="onChange($event)" name="CodeChantier"
              style="font-size: small;" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
      </div>
      <!-- Date du au -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Date</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate (ngModelChange)="onChange($event)" [(ngModel)]="filtreData.startDBp">
              <input matEndDate (ngModelChange)="onChange($event)" [(ngModel)]="filtreData.endDBp">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">date non valide</mat-error>
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">date non valide</mat-error>
          </mat-form-field>
        </div>
      </div>
      <!-- Statut -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          
          <app-custom-select-multiple-option 
          (selected)="onStatusChange($event)" [InputvaluesList]="listStatus" 
          [InputSelectedValues]="listStatusUpdated" [title]="'Statut'">
        </app-custom-select-multiple-option>
      
        </div>
      </div>
      <!-- Facture -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Facture</mat-label>
            <input matInput (ngModelChange)="onChange($event)" [(ngModel)]="filtreData.facture" name="status"
              style="font-size: small;" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
      </div>
      <!-- Date Facture -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Date Facture</mat-label>
            <mat-date-range-input [rangePicker]="pickerFacture">
              <input matStartDate (ngModelChange)="onChange($event)" [(ngModel)]="filtreData.startDFactBp">
              <input matEndDate (ngModelChange)="onChange($event)" [(ngModel)]="filtreData.endDFactBp">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerFacture"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerFacture></mat-date-range-picker>

            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">date non valide</mat-error>
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">date non valide</mat-error>
          </mat-form-field>
        </div>
      </div>
      
      <!-- Référence fournisseur -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Référence fournisseur</mat-label>
            <input matInput (ngModelChange)="onChange($event)" [(ngModel)]="filtreData.refFourn" name="refFourn"
              style="font-size: small;" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
      </div>
      <!-- NBC -->
      <div class="row">
        <div class="col-sm-6 margin_bm_20">
          <app-autocomplete-with-num (objetChange)="onChange($event)" libelle="N° de BC: du" [objets]="bcsStart"
          [(objet)]="filtreData.startBcNum" name="BC" [required]="false" (loadData)="loadData($event, bcService, 'bcsStart')">
          </app-autocomplete-with-num>
        </div>
        <div class="col-sm-6 margin_bm_20">
          <app-autocomplete-with-num (objetChange)="onChange($event)" libelle="au" [objets]="bcsEnd"
          [(objet)]="filtreData.endBcNum" name="BC" [required]="false" (loadData)="loadData($event, bcService, 'bcsEnd')">
          </app-autocomplete-with-num>
        </div>
      </div>
      <!-- NBP -->
      <div class="row">
        <div class="col-sm-6 margin_bm_20">
          <app-autocomplete-with-num (objetChange)="onChange($event)" libelle="N° Pièce: du" [objets]="bpsStart"
          [(objet)]="filtreData.startBpNum" name="BP" [required]="false" (loadData)="loadData($event, bpService, 'bpsStart')">
          </app-autocomplete-with-num>
        </div>
        <div class="col-sm-6 margin_bm_20">
          <app-autocomplete-with-num (objetChange)="onChange($event)" libelle="au" [objets]="bpsEnd"
          [(objet)]="filtreData.endBpNum" name="BP" [required]="false" (loadData)="loadData($event, bpService, 'bpsEnd')">
          </app-autocomplete-with-num>
        </div>
      </div>

      <div class="row">

        <!-- status Facturés -->
        <div class="col-sm-6 margin_bm_20">
          <form name="form" #f="ngForm" novalidate>
            <mat-form-field appearance="outline">
              <mat-label>Pièces facturés</mat-label>

              <mat-select multiple [(value)]="filtreData.bFacture">
                <mat-option [value]="true" (click)="onChange($event)">
                  Pièces facturés
                </mat-option>
                <mat-option [value]="false" (click)="onChange($event)">
                  Pièces non facturés
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
        <!--  status facturé -->
        <div class="col-sm-6 margin_bm_20">
          <form name="form" #f="ngForm" novalidate>
            <mat-form-field appearance="outline">
              <mat-label>Pièces validés</mat-label>

              <mat-select multiple [(value)]="filtreData.fValide" style="max-width: 100%;">
                <mat-option [value]="FlagEnum.All" (click)="onChange($event)">
                  Total
                </mat-option>
                <mat-option [value]="FlagEnum.Some" (click)="onChange($event)">
                  Partiel
                </mat-option>
                <mat-option [value]="FlagEnum.None" (click)="onChange($event)">
                  Aucun
                </mat-option>
              </mat-select>
            </mat-form-field> 
          </form>
        </div>

      </div>
      <div class="row">
        <!-- status Annulés -->
        <div class="col-sm-6 margin_bm_20">
          <form name="form" #f="ngForm" novalidate>
            <mat-form-field appearance="outline">
              <mat-label>Pièces annulés</mat-label>

              <mat-select multiple [(value)]="filtreData.bAnnule">
                <mat-option [value]="true" (click)="onChange($event)">
                  Pièces annulés
                </mat-option>
                <mat-option [value]="false" (click)="onChange($event)">
                  Pièces non annulés
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
        <!--  status Bloqués -->
        <div class="col-sm-6 margin_bm_20">
          <form name="form" #f="ngForm" novalidate>
            <mat-form-field appearance="outline">
              <mat-label>Pièces Bloqués</mat-label>

              <mat-select multiple [(value)]="filtreData.bBloque">
                <mat-option [value]="true" (click)="onChange($event)">
                  Pièces bloqués
                </mat-option>
                <mat-option [value]="false" (click)="onChange($event)">
                  Pièces non bloqués
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
*
      </div>  
    </div>
    <br>
    <br>
    <br>
  </mat-drawer>

  <mat-drawer-content>
    <div>
      <div class="row">
        <div class="col-sm-6">
          <h3>{{ title }}</h3>
        </div>
        <div *ngIf="isListAValide" class="col-sm-6" style="display: flex; justify-content: flex-end;">
          <button color="success" mat-raised-button type="button" (click)="onValidationBps()" [disabled]="selectedBpsChild.length === 0">
            <mat-icon>check</mat-icon>Valider des factures
          </button>
        </div>
      </div>
      <div class="col-sm-12">
        <mat-card>
          <mat-card-header>
            <mat-card-title>Résultats :
            </mat-card-title>
            <span class="filter-button">
              <mat-card-title>
                <button color="success" mat-raised-button type="button" (click)="onExport()">
                  <mat-icon>import_export</mat-icon>Export
                </button>
                <button color="primary" (click)="sideNav.toggle(); this.load();" mat-stroked-button>
                  <mat-icon color="primary" id="icon">filter_list</mat-icon>filtres
                </button>
              </mat-card-title>
            </span>
          </mat-card-header>
          <mat-card-content>
            <app-bp-list 
              [datasource]="bpList"
              [ifListAValide]="isListAValide"
              (selectedRowsEmit)="getSelectedBps($event)"
              [(filtreData)]="filtreData"
              [simpleQueryBpResponse]="simpleQueryBpResponse"
            ></app-bp-list>

          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </mat-drawer-content>
</mat-drawer-container>